import React from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubHookFormInput,
  HubHookFormSelect,
  HubHookFormSwitch,
  HubHookFormTimePicker,
  HubMaterialHookSelect,
  StationHookFormSelect,
} from "../../../components";
import { StyledHubCardStack } from "../styles";
import { useHighlightableField } from "../../../hooks";
import { FINISHING_FILTERS } from "../../../constants";

const gap = "10px";
const columnGap = "10px";

const filters = FINISHING_FILTERS?.map((f, idx) => ({ id: idx + 1, label: f }));

const PartFoundry = ({ basePath }) => {
  const { HighlightMenu, getFieldProps } = useHighlightableField();

  const p = `${basePath}.routing.0`;
  const cp = `${basePath}.config`;

  return (
    <StyledHubCardStack gap="25px">
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Foundry Details</Typography>
        <Stack gap="25px">
          <Stack direction="row" gap={columnGap}>
            <StationHookFormSelect
              name={`${p}.stationId`}
              label="Station"
              useDefault={false}
              department={4}
              {...getFieldProps(`${p}.stationId`)}
            />
            <HubMaterialHookSelect
              name={`details.materialId`}
              label="Metal Alloy"
              showOnlyGroup="Metal"
              useDefault={false}
              {...getFieldProps(`details.materialId`)}
            />
            <HubHookFormInput
              name={`${cp}.metalTemp`}
              placeholder="Ex. 12"
              label="Metal Temp"
              endAdornment="°F"
              isNumber
              {...getFieldProps(`${cp}.metalTemp`)}
            />
            <HubHookFormInput
              name={`${cp}.shellTemp`}
              placeholder="Ex. 12"
              label="Shell Temp"
              endAdornment="°F"
              isNumber
              {...getFieldProps(`${cp}.shellTemp`)}
            />
          </Stack>
          <Stack direction="row" gap={columnGap}>
            <HubHookFormInput
              name={`${cp}.poundsPerHeat`}
              label="Pounds Per Heat"
              placeholder="Ex. 12"
              isNumber
              {...getFieldProps(`${cp}.poundsPerHeat`)}
            />
            <HubHookFormInput
              name={`${cp}.treesPerHeat`}
              label="Trees Per Heat"
              placeholder="Ex. 12"
              isNumber
              {...getFieldProps(`${cp}.treesPerHeat`)}
            />
            <HubHookFormSelect
              name={`${cp}.filter`}
              label="Filter"
              options={filters}
              useDefault
              {...getFieldProps(`${cp}.filter`)}
            />
            <HubHookFormInput
              name={`${cp}.weight`}
              label="Metal Weight"
              placeholder="ex. 4.55"
              endAdornment="lbs"
              isDecimal
              {...getFieldProps(`${cp}.weight`)}
            />
          </Stack>
          <Stack direction="row" gap={columnGap}>
            <HubHookFormTimePicker
              name={`${p}.leadTime`}
              label="Lead Time"
              placeholder="Ex. 12"
              fields={["days"]}
              required
              {...getFieldProps(`${p}.leadTime`)}
            />
            <HubHookFormTimePicker
              name={`${p}.cycleTime`}
              label="Cycle Time"
              placeholder="Ex. 0.24"
              required
              {...getFieldProps(`${p}.cycleTime`)}
            />
          </Stack>
          <Stack direction="row" gap={columnGap}>
            <HubHookFormSwitch
              name={`${cp}.wrapTree`}
              label="Wrap Tree"
              labelPlacement="end"
              disableHelperText
              isCheckbox
              {...getFieldProps(`${cp}.wrapTree`)}
            />
            <HubHookFormSwitch
              name={`${cp}.hotTop`}
              label="Hot Top"
              labelPlacement="end"
              disableHelperText
              isCheckbox
              {...getFieldProps(`${cp}.hotTop`)}
            />
            <HubHookFormSwitch
              name={`${cp}.cover`}
              label="Cover"
              labelPlacement="end"
              disableHelperText
              isCheckbox
              {...getFieldProps(`${cp}.cover`)}
            />
          </Stack>
        </Stack>
      </Stack>
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Foundry Notes</Typography>
        <HubHookFormInput
          name={`${basePath}.notes`}
          label="Special Instructions"
          placeholder="Dip notes..."
          rows={5}
          multiline
          {...getFieldProps(`${basePath}.notes`)}
        />
      </Stack>
      {HighlightMenu}
    </StyledHubCardStack>
  );
};

export default PartFoundry;
